import React, {Component} from "react";
import {Link} from "react-router-dom";
import flow1 from "../../../../../assets/img/flow1.png";
import './Flow.css';


class Inquiry extends Component {
    render() {
        return (

            <div className="begin-div">
               Inquiry
            </div>

        );
    }


}

export default Inquiry;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Inquiry.js